import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: () => import('@/views/pages/pages/authentication/nextsense/login.vue')
  // },

  {
    path: "/",
    redirect: "/home/index"
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/views/pages/pages/authentication/nextsense/login.vue'),
  },
  {
    path: "/impersonate",
    name: "impersonate",
    component: () => import('@/views/pages/pages/authentication/nextsense/impersonate.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/pages/pages/authentication/nextsense/register.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/pages/authentication/forgot-password.vue')
  },
  // {
  //   path: '/set-password',
  //   name: 'set-password',
  //   component: () => import('@/views/pages/pages/authentication/set-password.vue')
  // },

  {
  path: '/set-password/:token',
  name: 'set-password',
  component: () => import('@/views/pages/pages/authentication/set-password.vue'),
  props: true
},

  {
    path: '/otp',
    name: 'otp',
    component: () => import('@/views/pages/pages/authentication/otp.vue')
  },
  {
    path: '/lock-screen',
    name: 'lock-screen',
    component: () => import('@/views/pages/pages/authentication/lock-screen.vue')
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: () => import('@/views/pages/pages/coming-soon.vue')
  },
  {
    path: '/under-construction',
    name: 'under-construction',
    component: () => import('@/views/pages/pages/under-construction.vue')
  },
  {
    path: '/error-500',
    name: 'error-500',
    component: () => import('@/views/pages/pages/error/error-500.vue')
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/pages/error/error-404.vue')
  },
  {
    path: '/home',
    component: () => import('@/views/pages/home/home-index.vue'),
    children: [
      { path: '', redirect: '/home/index' },
      { path: 'index', component: () => import('@/views/pages/home/nextsense/home.vue') },
      { path: 'index-2', component: () => import('@/views/pages/home/home-two/home-two.vue') },
      { path: 'index-3', component: () => import('@/views/pages/home/home-three/home-three.vue') },
      { path: 'index-4', component: () => import('@/views/pages/home/home-four/home-four.vue') },
      { path: 'index-5', component: () => import('@/views/pages/home/home-five/home-five.vue') },
      { path: 'index-6', component: () => import('@/views/pages/home/home-six/home-six.vue') },
    ]
  },
  {
    path: '/instructor',
    component: () => import('@/views/pages/dashboard/instructor/instructor-index.vue'),
    children: [
      { path: '', redirect: '/instructor/instructor-dashboard' },
      { path: 'instructor-dashboard', component: () => import('@/views/pages/dashboard/instructor/instructor-dashboard.vue') },
      { path: 'instructor-profile', component: () => import('@/views/pages/dashboard/instructor/instructor-profile.vue') },
      { path: 'instructor-course', component: () => import('@/views/pages/dashboard/instructor/instructor-course.vue') },
      { path: 'instructor-course-grid', component: () => import('@/views/pages/dashboard/instructor/instructor-course-grid.vue') },
      { path: 'instructor-announcements', component: () => import('@/views/pages/dashboard/instructor/instructor-announcements.vue') },
      { path: 'instructor-assignment', component: () => import('@/views/pages/dashboard/instructor/instructor-assignment.vue') },
      { path: 'instructor-quiz', component: () => import('@/views/pages/dashboard/instructor/instructor-quiz.vue') },
      { path: 'instructor-quiz-results', component: () => import('@/views/pages/dashboard/instructor/instructor-quiz-results.vue') },
      { path: 'instructor-quiz-questions', component: () => import('@/views/pages/dashboard/instructor/instructor-quiz-questions.vue') },
      { path: 'instructor-certificate', component: () => import('@/views/pages/dashboard/instructor/instructor-certificate.vue') },
      { path: 'instructor-earnings', component: () => import('@/views/pages/dashboard/instructor/instructor-earnings.vue') },
      { path: 'instructor-payout', component: () => import('@/views/pages/dashboard/instructor/instructor-payout.vue') },
      { path: 'instructor-statements', component: () => import('@/views/pages/dashboard/instructor/instructor-statements.vue') },
      { path: 'instructor-message', component: () => import('@/views/pages/dashboard/instructor/instructor-message.vue') },
      { path: 'instructor-tickets', component: () => import('@/views/pages/dashboard/instructor/instructor-tickets.vue') },
      { path: 'instructor-settings', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-settings.vue') },
      { path: 'instructor-change-password', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-change-password.vue') },
      { path: 'instructor-plans', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-plans.vue') },
      { path: 'instructor-social-profiles', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-social-profiles.vue') },
      { path: 'instructor-linked-accounts', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-linked-accounts.vue') },
      { path: 'instructor-notifications', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-notifications.vue') },
      { path: 'instructor-integrations', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-integrations.vue') },
      { path: 'instructor-withdraw', component: () => import('@/views/pages/dashboard/instructor/settings/instructor-withdraw.vue') },
    ]
  },
  {
    path: '/instructor-students',
    component: () => import('@/views/pages/dashboard/instructor/students/instructor-student.vue'),
    children: [
      { path: '', redirect: '/instructor-students/student-grid' },
      { path: 'student-grid', component: () => import('@/views/pages/dashboard/instructor/students/student-grid.vue') },
      { path: 'student-list', component: () => import('@/views/pages/dashboard/instructor/students/student-list.vue') },      
      { path: 'student-details', component: () => import('@/views/pages/dashboard/instructor/students/student-details.vue') },
    ]
  },
  {
    path: '/blogs',
    component: () => import('@/views/pages/blogs/blog-layouts/blog-layouts.vue'),
    children: [
      { path: '', redirect: '/blogs/blog-details' },
      { path: 'blog-details', component: () => import('@/views/pages/blogs/blog-details/blog-details.vue') },
      { path: 'blog-details-left-sidebar', component: () => import('@/views/pages/blogs/blog-details/blog-details-left-sidebar.vue') },
      { path: 'blog-details-right-sidebar', component: () => import('@/views/pages/blogs/blog-details/blog-details-right-sidebar.vue') },
    ]
  },
  {
    path: '/blog-layouts',
    component: () => import('@/views/pages/blogs/blog-details/blogs-index.vue'),
    children: [
      { path: '', redirect: '/blog-layouts/blog-grid' },
      { path: 'blog-grid', component: () => import('@/views/pages/blogs/blog-layouts/blog-grid.vue') },
      { path: 'blog-2-grid', component: () => import('@/views/pages/blogs/blog-layouts/blog-2-grid.vue') },
      { path: 'blog-3-grid', component: () => import('@/views/pages/blogs/blog-layouts/blog-3-grid.vue') },
      { path: 'blog-masonry', component: () => import('@/views/pages/blogs/blog-layouts/blog-masonry.vue') },
      { path: 'blog-left-sidebar', component: () => import('@/views/pages/blogs/blog-layouts/blog-left-sidebar.vue') },
      { path: 'blog-right-sidebar', component: () => import('@/views/pages/blogs/blog-layouts/blog-right-sidebar.vue') },
      { path: 'blog-carousal', component: () => import('@/views/pages/blogs/blog-layouts/blog-carousal.vue') },
    ]
  },
  {
    path: '/pages',
    component: () => import('@/views/pages/pages/pages-index.vue'),
    children: [
      { path: '', redirect: '/pages/about-us' },
      { path: 'about-us', component: () => import('@/views/pages/pages/nextsense/about-us.vue') },
      { path: 'contact-us', component: () => import('@/views/pages/pages/nextsense/contact-us.vue') },
      { path: 'donate', component: () => import('@/views/pages/pages/nextsense/donate.vue') },
      { path: 'careers', component: () => import('@/views/pages/pages/nextsense/careers.vue') },
      { path: 'find-a-centre', component: () => import('@/views/pages/pages/nextsense/find-a-centre.vue') },
      { path: 'search', component: () => import('@/views/pages/pages/nextsense/search.vue') },
      { path: 'notifications', component: () => import('@/views/pages/pages/notifications.vue') },
      { path: 'become-an-instructor', component: () => import('@/views/pages/pages/become-an-instructor.vue') },
      { path: 'testimonials', component: () => import('@/views/pages/pages/testimonials.vue') },
      { path: 'pricing-plan', component: () => import('@/views/pages/pages/pricing-plan.vue') },
      { path: 'faq', component: () => import('@/views/pages/pages/faq.vue') },
      { path: 'terms-and-conditions', component: () => import('@/views/pages/pages/terms-and-conditions.vue') },
      { path: 'privacy-policy', component: () => import('@/views/pages/pages/privacy-policy.vue') },
    ]
  },
  {
    path: '/pages-instructor',
    component: () => import('@/views/pages/pages/instructor/pages-instructor.vue'),
    children: [
      { path: '', redirect: '/pages-instructor/instructor-grid' },
      { path: 'instructor-grid', component: () => import('@/views/pages/pages/instructor/instructor-grid.vue') },
      { path: 'instructor-list', component: () => import('@/views/pages/pages/instructor/instructor-list.vue') },
      { path: 'instructor-details', component: () => import('@/views/pages/pages/instructor/instructor-details.vue') },
    ]
  },
  {
    path: '/course',
    component: () => import('@/views/pages/courses/course/course-index.vue'),
    children: [
      { path: '', redirect: '/course/course-grid' },
      { path: 'course-grid', component: () => import('@/views/pages/courses/course/nextsense/course-grid.vue') },
      { path: 'course-list', component: () => import('@/views/pages/courses/course/course-list.vue') },
      { path: 'coursedetails/:cid', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue'), name: 'CourseDetailsGrid' },
    ]
  },
  // Client-requested clean URLs per course type. Reuse the same grid/details
  // components as /course/course-grid -- `meta.courseType` tells course-grid.vue
  // which subset to show, and :cid here carries the course's slug (the detail
  // page and API already accept either a slug or a legacy numeric id).
  {
    path: '/scheduled-courses',
    component: () => import('@/views/pages/courses/course/nextsense/course-grid.vue'),
    name: 'ScheduledCourses',
    meta: { courseType: 'Scheduled' },
  },
  { path: '/scheduled-courses/:cid', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue'), name: 'ScheduledCourseDetails' },
  {
    path: '/ondemand-courses',
    component: () => import('@/views/pages/courses/course/nextsense/course-grid.vue'),
    name: 'OnDemandCourses',
    meta: { courseType: 'OnDemand' },
  },
  { path: '/ondemand-courses/:cid', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue'), name: 'OnDemandCourseDetails' },
  {
    path: '/certificate-courses',
    component: () => import('@/views/pages/courses/course/nextsense/course-grid.vue'),
    name: 'CertificateCourses',
    meta: { courseType: 'Certificate' },
  },
  { path: '/certificate-courses/:cid', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue'), name: 'CertificateCourseDetails' },
  {
    path: '/category',
    component: () => import('@/views/pages/courses/category/category-index.vue'),
    children: [
      { path: '', redirect: '/category/course-category-1' },
      { path: 'course-category-1', component: () => import('@/views/pages/courses/category/course-category.vue') },
      { path: 'course-category-2', component: () => import('@/views/pages/courses/category/course-category-2.vue') },
      { path: 'course-category-3', component: () => import('@/views/pages/courses/category/course-category-3.vue') },
    ]
  },
  {
    path: '/details',
    component: () => import('@/views/pages/courses/details/details-index.vue'),
    children: [
      { path: '', redirect: '/details/course-details-1/' },
      { path: 'course-details-1', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue')},
       { path: 'coursedetails/:cid', component: () => import('@/views/pages/courses/details/nextsense/course-details.vue'), name: 'CourseDetails' },
      { path: 'course-details-2', component: () => import('@/views/pages/courses/details/course-details-2.vue') },
       { path: 'EnrollCourseDetails/:cid', component: () => import('@/views/pages/courses/details/enroll-course-details.vue'), name: 'EnrollCourseDetails' },
    ]
  },
  {
    path: '/courses',
    component: () => import('@/views/pages/courses/courses-index.vue'),
    children: [
      { path: '', redirect: '/courses/course-resume' },
      { path: 'course-resume', component: () => import('@/views/pages/courses/course-resume.vue') },
      { path: 'course-watch', component: () => import('@/views/pages/courses/course-watch.vue') },
      { path: 'cart', component: () => import('@/views/pages/courses/nextsense/course-cart.vue') },
      { path: 'checkout', component: () => import('@/views/pages/courses/nextsense/course-checkout.vue') },
      { path: 'order-confirmation', component: () => import('@/views/pages/courses/nextsense/order-confirmation.vue') },
      { path: 'add-course', component: () => import('@/views/pages/courses/add-course/add-course.vue') },
    ]
  },
  {
    path: '/students',
    component: () => import('@/views/pages/dashboard/student/student-index.vue'),
    children: [
      { path: '', redirect: '/students/student-dashboard' },
      { path: 'student-dashboard', component: () => import('@/views/pages/dashboard/student/nextsense/student-dashboard.vue') },
      { path: 'student-profile', component: () => import('@/views/pages/dashboard/student/nextsense/student-profile.vue') },
      { path: 'student-courses', component: () => import('@/views/pages/dashboard/student/nextsense/student-courses.vue') },
      { path: 'student-certificates', component: () => import('@/views/pages/dashboard/student/nextsense/student-certificates.vue') },
      { path: 'student-wishlist', component: () => import('@/views/pages/dashboard/student/student-wishlist.vue') },
      { path: 'student-reviews', component: () => import('@/views/pages/dashboard/student/student-reviews.vue') },
      { path: 'student-quiz', component: () => import('@/views/pages/dashboard/student/nextsense/student-quiz.vue') },
      { path: 'student-quiz-questions/:quiz_id', component: () => import('@/views/pages/dashboard/student/nextsense/student-quiz-questions.vue'),name: 'student-quiz-questions' },
      { path: 'student-order-history', component: () => import('@/views/pages/dashboard/student/nextsense/student-order-history.vue') },
      { path: 'student-referral', component: () => import('@/views/pages/dashboard/student/student-referral.vue') },
      { path: 'student-messages', component: () => import('@/views/pages/dashboard/student/student-messages.vue') },
      { path: 'student-tickets', component: () => import('@/views/pages/dashboard/student/student-tickets.vue') },
      { path: 'student-settings', component: () => import('@/views/pages/dashboard/student/settings/nextsense/student-settings.vue') },
      { path: 'student-change-password', component: () => import('@/views/pages/dashboard/student/settings/student-change-password.vue') },
      { path: 'student-social-profile', component: () => import('@/views/pages/dashboard/student/settings/student-social-profile.vue') },
      { path: 'student-linked-accounts', component: () => import('@/views/pages/dashboard/student/settings/student-linked-accounts.vue') },
      { path: 'student-notifications', component: () => import('@/views/pages/dashboard/student/settings/student-notifications.vue') },
      { path: 'student-billing-address', component: () => import('@/views/pages/dashboard/student/settings/student-billing-address.vue') },
    ]
  },
 
];

export const router = createRouter({
  history: createWebHistory("/"),
  linkActiveClass: "active",
  routes,
});
router.beforeEach((to, from, next) => {
  // Scroll to the top of the page
  window.scrollTo({ top: 0, behavior: "smooth" });

  // Continue with the navigation
  next();
});
